import Cookies from 'js-cookie';

export const recoverSessionId = () => {
  const url = new URL(window.location.href);
  const override = url.searchParams.get('sessionId');
  if (override) {
    Cookies.set('sessionId', override);
    return override;
  }
  if (window.location.hash === '#new') {
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
    Cookies.remove('sessionId');
    return undefined;
  }
  return Cookies.get('sessionId');
};

export default recoverSessionId;
